import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { submitQuestion } from './cringeSlice';

/** "Time: mm:ss" (left) and "Points: n" (right) — the .timer-back / .score boxes on every stage. */
export function TopBar({ time, points, children }) {
  return (
    <div className="cr-topbar">
      <div className="cr-timer">Time: {time}</div>
      <div className="cr-topbar-right">
        {children}
        <div className="cr-score">Points: <span>{points}</span></div>
      </div>
    </div>
  );
}

/** The white uppercase story box above each game (.gameHead). */
export function GameHead({ children }) {
  return <h4 className="cr-gamehead">{children}</h4>;
}

/**
 * The Swal popups of the PHP game: img/popup.png as the background, white text and
 * img/cross.png top-right as the only way to close it.
 */
export function Popup({ onClose, children }) {
  return (
    <div className="cr-overlay">
      <div className="cr-popup" style={{ backgroundImage: 'url(/cringe/img/popup.png)' }}>
        <button type="button" className="cr-popup-close" onClick={onClose} aria-label="Close">
          <img src="/cringe/img/cross.png" alt="" />
        </button>
        <div className="cr-popup-body">{children}</div>
      </div>
    </div>
  );
}

export function RotateNotice() {
  return <div className="cr-rotate">Please rotate your device for the best experience</div>;
}

/** Returns save(question, score, timer) -> the server state, or null (after telling the player) on failure. */
export function useSaveScore() {
  const dispatch = useDispatch();
  return async (question, score, timer, { quiet = false } = {}) => {
    const res = await dispatch(submitQuestion({ question, score, timer }));
    if (submitQuestion.rejected.match(res)) {
      if (!quiet) Swal.fire('', res.payload || 'Could not save your progress. Please try again.', 'error');
      else console.error('Score not saved:', res.payload);
      return null;
    }
    return res.payload;
  };
}
